<!--
 * @Description:维修质检
 * @Author: ChenXueLin
 * @Date: 2022-03-04 09:28:40
 * @LastEditTime: 2022-07-15 16:02:31
 * @LastEditors: ChenXueLin
-->
<template>
  <div class="content-view-wrapper pd-10">
    <div
      class="content-view section-wrapper"
      ref="sectionWrapper"
      v-loading="loading"
      :element-loading-background="loadingBackground"
    >
      <!-- 搜索头部 start -->
      <table-title @resize="handleTableTitleResize">
        <template v-slot:searchForm>
          <el-form class="search-list" ref="searchForm" :model="searchForm">
            <el-form-item class="search-item--1" prop="itemIdList">
              <input-plus
                v-model="searchForm.itemIdList"
                valueType="Array"
                placeholder="工单ID"
                title="工单ID"
                label="工单ID"
                clearable
              ></input-plus>
            </el-form-item>
            <el-form-item class="search-item--1" prop="customerName">
              <el-input
                v-model="searchForm.customerName"
                placeholder="客户名称"
                title="客户名称"
              ></el-input>
            </el-form-item>
            <el-form-item class="search-item--1" prop="engineerName">
              <el-input
                v-model="searchForm.engineerName"
                placeholder="工程师"
                title="工程师"
              ></el-input>
            </el-form-item>
            <el-form-item class="search-item--1" prop="inspectionOperatorId">
              <all-user-search
                v-model="searchForm.inspectionOperatorId"
                clear
                placeholder="质检人"
                clearable
                title="质检人"
                :propsConfig="{
                  id: 'employeeId',
                  label: 'employeeName'
                }"
              >
              </all-user-search>
            </el-form-item>
            <el-form-item prop="taskInspectionStatus">
              <e6-vr-select
                v-model="searchForm.taskInspectionStatus"
                :data="workStatusList"
                placeholder="工单状态"
                title="工单状态"
                clearable
                virtual
                multiple
                :is-title="true"
                :props="{
                  id: 'codeValue',
                  label: 'codeName'
                }"
              ></e6-vr-select>
            </el-form-item>
            <el-form-item class="search-item--1" prop="taskSource">
              <e6-vr-select
                v-model="searchForm.taskSource"
                :data="taskSourceList"
                placeholder="工单来源"
                title="工单来源"
                multiple
                clearable
                :props="{
                  id: 'codeValue',
                  label: 'codeName'
                }"
              ></e6-vr-select>
            </el-form-item>
            <el-form-item class="search-item--1" prop="facilitatorName">
              <el-input
                v-model="searchForm.facilitatorName"
                placeholder="服务商名称"
                title="服务商名称"
              ></el-input>
            </el-form-item>
            <el-form-item class="search-item--1" prop="sceneName">
              <el-input
                v-model="searchForm.sceneName"
                placeholder="场景名称"
                title="场景名称"
              ></el-input>
            </el-form-item>
            <el-form-item prop="isNeedVisit">
              <e6-vr-select
                v-model="searchForm.isNeedVisit"
                :data="emusList"
                placeholder="是否需要上门"
                title="是否需要上门"
                clearable
                virtual
                :is-title="true"
              ></e6-vr-select>
            </el-form-item>
            <el-form-item prop="taskInspectionType">
              <e6-vr-select
                v-model="searchForm.taskInspectionType"
                :data="taskTypeList"
                placeholder="工单类型"
                title="工单类型"
                clearable
                virtual
                :is-title="true"
                :props="{
                  id: 'codeValue',
                  label: 'codeName'
                }"
              ></e6-vr-select>
            </el-form-item>
            <el-form-item class="search-item--1" prop="workTypeTagList">
              <e6-vr-select
                v-model="searchForm.workTypeTagList"
                :data="workTypeTagList"
                placeholder="工单类型标签"
                title="工单类型标签"
                clearable
                multiple
                :props="{
                  id: 'codeValue',
                  label: 'codeName'
                }"
              ></e6-vr-select>
            </el-form-item>
            <el-form-item prop="inspectionFail">
              <e6-vr-select
                v-model="searchForm.inspectionFail"
                :data="inspectionFailList"
                placeholder="质检不通过原因"
                title="质检不通过原因"
                clearable
                virtual
                :is-title="true"
                :props="{
                  id: 'codeValue',
                  label: 'codeName'
                }"
              ></e6-vr-select>
            </el-form-item>
            <el-form-item prop="zeroSettle">
              <e6-vr-select
                v-model="searchForm.zeroSettle"
                :data="emusList"
                placeholder="是否0结算"
                title="是否0结算"
                clearable
                virtual
                :is-title="true"
              ></e6-vr-select>
            </el-form-item>
            <el-form-item prop="isStartQuality">
              <e6-vr-select
                v-model="searchForm.isStartQuality"
                :data="isStartQualityList"
                placeholder="是否开始质检"
                title="是否开始质检"
                clearable
                virtual
                :is-title="true"
              ></e6-vr-select>
            </el-form-item>
            <el-form-item prop="inspectionTag">
              <e6-vr-select
                v-model="searchForm.inspectionTag"
                :data="inspectionTagList"
                placeholder="质检标签"
                title="质检标签"
                clearable
                virtual
                :is-title="true"
                :props="{
                  id: 'codeValue',
                  label: 'codeName'
                }"
              ></e6-vr-select>
            </el-form-item>
            <el-form-item class="search-item--1" prop="projectIdList">
              <remote-search
                v-model="searchForm.projectIdList"
                clearable
                multiple
                placeholder="项目名称"
                title="项目名称"
                :props="{
                  id: 'projectId',
                  label: 'projectName'
                }"
                :queryListAPI="projectNameListPage"
                searchValueKey="projectName"
              ></remote-search>
            </el-form-item>
            <el-form-item class="search-item--1" prop="warnType">
              <e6-vr-select
                v-model="searchForm.warnTypeList"
                :data="warnTypeList"
                multiple
                placeholder="项目标签"
                title="项目标签"
                clearable
                :props="{
                  id: 'codeValue',
                  label: 'codeName'
                }"
              ></e6-vr-select>
            </el-form-item>
            <el-form-item class="search-item--1" prop="classifyNos">
              <remote-search
                v-model="searchForm.classifyNoList"
                clearable
                multiple
                :queryListAPI="getMaterialClassifyList"
                placeholder="物料分类名称"
                title="物料分类名称"
                :props="{
                  id: 'classifyNo',
                  label: 'classifyName'
                }"
                searchValueKey="classifyName"
              ></remote-search>
            </el-form-item>
            <el-form-item class="search-item--2" prop="createTime">
              <e6-date-picker
                popper-class="no-atTheMoment"
                label="质检单创建时间"
                ref="effectiveDatePicker"
                v-model="searchForm.createTime"
                title="质检单创建时间"
                :picker-options="pickerOptions('searchForm.createTime')"
                :default-time="['00:00:00', '23:59:59']"
                start-placeholder="质检单创建时间（始）"
                end-placeholder="质检单创建时间（止）"
              ></e6-date-picker>
            </el-form-item>

            <el-form-item class="search-item--buttons">
              <el-button type="primary" @click="handleSearch">查询</el-button>
              <el-button class="reset" @click="handleReset">重置</el-button>
            </el-form-item>
          </el-form>
        </template>
        <template v-slot:operateAction>
          <el-button type="primary" @click="startInspection" v-has="122"
            >开始质检</el-button
          >
          <el-button type="primary" @click="batchRecord">
            质检记录
          </el-button>
          <el-button type="primary" @click="submitOrder">提交工单</el-button>
          <el-button type="primary" @click="handleAudit" v-has="123"
            >复核通过</el-button
          >
          <el-button type="primary" @click="handleTurnDown" v-has="124"
            >驳回</el-button
          >
          <i
            class="e6-icon-export_fill"
            title="导出"
            @click="handleExport"
            v-has="105"
          ></i>
        </template>
      </table-title>
      <!-- 搜索头部 end -->
      <!-- 表格 start -->
      <section class="table-wrapper">
        <el-table
          border
          :height="resizeViewHeight + 'px'"
          :data="tableData"
          highlight-current-row
          class="elTable"
          ref="elTable"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="50"></el-table-column>
          <!-- 序号 start -->
          <el-table-column
            label="序号"
            width="50"
            fixed="left"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span>
                {{
                  scope.$index +
                    1 +
                    (searchForm.pageIndex - 1) * searchForm.pageSize
                }}
              </span>
            </template>
          </el-table-column>
          <!-- 序号 end -->
          <el-table-column
            show-overflow-tooltip
            v-for="(column, index) in maintenColumnData"
            :key="index"
            :prop="column.fieldName"
            :label="column.fieldLabel"
            :min-width="column.width"
            :fixed="column.fixed"
            :align="column.align"
            header-align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="column.fieldName === 'detectionFinishTimeList'">
                <div
                  v-for="(item, index) in row.detectionFinishTimeList"
                  :key="index"
                >
                  <div :data-title="item" class="content-text">
                    {{ item.materialName }} :{{ item.detectionFinishTime }}
                  </div>
                </div>
              </div>
              <div v-else-if="column.fieldName === 'serverOpenTimeList'">
                <div
                  v-for="(item, index) in row.serverOpenTimeList"
                  :key="index"
                >
                  <div :data-title="item" class="content-text">
                    {{ item.materialName }} :{{ item.detectionFinishTime }}
                  </div>
                </div>
              </div>
              <div v-else-if="column.fieldName === 'fileUrlList'">
                <el-image
                  v-for="(item, index) in row.fileUrlList"
                  :key="index"
                  :src="item"
                  style="width:30px;height:30px;margin-right:10px;"
                  :preview-src-list="[item]"
                ></el-image>
              </div>
              <span v-else>{{ row[column.fieldName] }}</span>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            align="center"
            label="操作"
            width="160"
          >
            <template slot-scope="scope">
              <e6-td-operate
                :data="getOperateList(scope.row)"
                @command="handleOperate($event, scope.row)"
              ></e6-td-operate>
            </template>
          </el-table-column>
        </el-table>
      </section>
      <!-- 表格 end -->

      <!-- 分页 start -->
      <section class="pagination-wrapper fixed-section" ref="paginationWrapper">
        <el-pagination
          :page-size.sync="searchForm.pageSize"
          :current-page.sync="searchForm.pageIndex"
          :page-sizes="pageSizes"
          :layout="layout"
          :total="total"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </section>
      <!-- 分页 end -->
    </div>
    <rejected-dialog
      :rejectedVisible.sync="rejectedVisible"
      :needTip="needTip"
      @confirm="confirmTurnDown"
      ref="rejectedDialog"
    ></rejected-dialog>
    <audit-dialog
      :auditVisible.sync="auditVisible"
      @confirm="confirmAudit"
      ref="auditDialog"
    ></audit-dialog>
    <!-- 质检记录 -->
    <inspection-record-dialog
      :recordVisible.sync="recordVisible"
      ref="inspectionRecordDialog"
      :taskInspectionId="clickTaskInspectionId"
      @confirm="confirmRecord"
      type="maintenQualityInspection"
    ></inspection-record-dialog>
    <batch-record-dialog
      :batchRecordVisible.sync="batchRecordVisible"
      ref="batchInspectionRecordDialog"
      :inspectionPhotoList="inspectionPhotoList"
      @confirm="confirmRecord"
      type="maintenQualityInspection"
    ></batch-record-dialog>
  </div>
</template>

<script>
import mixin from "./mixin";
import {
  getRepairTaskInspectionPage,
  exportRepairTaskInspection,
  projectNameListPage
} from "@/api";
import RejectedDialog from "@/components/rejectedDialog.vue";
import AuditDialog from "./auditDialog.vue";
import inspectionRecordDialog from "./inspectionRecordDialog";
import batchRecordDialog from "./batchRecordDialog";
import { maintenColumnData } from "./columnData";
import allUserSearch from "@/components/allUserSearch";
import inputPlus from "@/components/inputPlus";
const nowTime = new Date().getTime(); // 打开页面时的时间戳

export default {
  name: "maintenQualityInspection",
  data() {
    return {
      type: "maintenQualityInspection",
      queryListAPI: getRepairTaskInspectionPage,
      maintenColumnData,
      exportDataApi: exportRepairTaskInspection,
      projectNameListPage,
      searchForm:{
        createTime: [nowTime - 2592000000], //创建日期
      }
    };
  },
  mixins: [mixin],
  components: {
    RejectedDialog,
    AuditDialog,
    inspectionRecordDialog,
    allUserSearch,
    inputPlus,
    batchRecordDialog
  },
  computed: {},
  watch: {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.el-table .cell {
  white-space: pre-line;
}
</style>
